import {compose} from 'redux';
import withCitiesAndStreets from '../../../../../../common/components/hoc-helpers/withCitiesAndStreets';
import DataTableWithFilters from './DataTableWithFilters';

export default compose(
  withCitiesAndStreets
)(DataTableWithFilters);
